import { render, staticRenderFns } from "./AdminUserStatsCard.vue?vue&type=template&id=104b2381"
import script from "./AdminUserStatsCard.vue?vue&type=script&lang=ts"
export * from "./AdminUserStatsCard.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports